import { SVGAttributes } from "react";

export function EmptyFolderPlusIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M6.5 14.0833C6.5 12.6906 7.62894 11.5417 9.02174 11.5417H19.4565C20.013 11.5417 20.547 11.7745 20.9405 12.1881L23.5 14.875H42.9783C44.3711 14.875 45.5 16.0239 45.5 17.4167V37.9167C45.5 39.3094 44.3711 40.4583 42.9783 40.4583H9.02174C7.62894 40.4583 6.5 39.3094 6.5 37.9167V14.0833Z"
        stroke="#D4D4D8"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M26 22.75V32.5" stroke="#D4D4D8" strokeWidth="2" strokeLinecap="round" />
      <path d="M21.125 27.625H30.875" stroke="#D4D4D8" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
